require('./cardPeriodicLoadsView.scss');

// @vendor
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const { isEmpty } = require('lodash');

// @helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const { toFirstUppercase, getLastNChars } = require('utilities/stringHelper');
const { PAGE_GENERIC, recordPath } = require('utilities/tagging');

// @commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const CardHeaderDetails = require('components/cards/cardHeaderDetails/cardHeaderDetails');
const { LastMovementsTable } = require('commonsComponents/lastMovementsTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { EmptyState } = require('commonsComponents/emptyState');
const { LoadingSection } = require('commonsComponents/loadingSection');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');

// @components
const PeriodicLoadsTableRow = require('./components/periodicLoadsTableRow/periodicLoadsTableRow');
const { PeriodicLoadsTableInfoRow } = require('./components/periodicLoadsTableInfoRow/periodicLoadsTableInfoRow');
const CardMoreOptionsButton = require('components/cards/cardMoreOptionsButton/cardMoreOptionsButton');
const PeriodicLoadsFilter = require('./components/periodicLoadsFilter/periodicLoadsFilter');
const PeriodicLoadsAppliedFilter = require('./components/periodicLoadsAppliedFilter/periodicLoadsAppliedFilter');

// @constants
const { LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY } = require('constants/commonsComponents');
const { GRAPHIC_TUTOR_TYPE_3 } = require('constants/index');

// @ actions
const cardPeriodicLoadsActions = require('actions/cardPeriodicLoads');
const cardsAliasActions = require('actions/postCardAlias');

class CardPeriodicLoadsView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expandedRowId: '',
            filterSettingsOpen: false
        };

        this.handleRowClick = this.handleRowClick.bind(this);
        this.onPostAlias = this.onPostAlias.bind(this);
        this.handleToggleFilters = this.handleToggleFilters.bind(this);
        this.handleSetFilters = this.handleSetFilters.bind(this);
        this.handleClearFilters = this.handleClearFilters.bind(this);
        this.handleResetFilters = this.handleResetFilters.bind(this);
    }

    componentDidMount() {
        this.getList();
    }

    componentWillUnmount() {
        this.props.clearFilters();
    }

    getList() {
        const {
            getPeriodicLoadsList,
            immCards,
            match: { params: { cardId } }
        } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);
        getPeriodicLoadsList(immCard);

        const tagging = immCard.get('tagging');
        recordPath('tarjeta/open-young-periodic-loads', PAGE_GENERIC, '', '', tagging);
    }

    handleSetFilters(filters) {
        this.props.setFilters(filters);
        this.getList();
    }

    handleClearFilters() {
        this.props.clearFilters();
        this.getList();
    }

    handleResetFilters(filterKey) {
        this.props.resetFilters(filterKey);
        this.getList();
    }

    handleRowClick(rowId) {
        this.setState({
            expandedRowId: rowId === this.state.expandedRowId ? '' : rowId
        });
    }

    onPostAlias(value) {
        const { match: { params: { cardId } }, postAlias } = this.props;
        postAlias(cardId, value);
    }

    handleToggleFilters() {
        this.setState({
            filterSettingsOpen: !this.state.filterSettingsOpen
        });
    }

    render() {
        const {
            cardPeriodicLoads,
            immCards,
            immScreen,
            match: { params: { cardId } },
            flagBasedFeatures
        } = this.props;
        const immCard = immCards.get('byId').get(cardId);
        const immFilters = cardPeriodicLoads.get('filters');
        if (immCard) {
            const immAlias = immCard.get('alias');
            const titleEditable = immAlias.get('isUpdating')
                ? immAlias.get('tentative')
                : immAlias.get('current');
            const language = getLanguage();
            const type = immCard.get('type');
            const subtitleLeft = formatText(`cards-${type}`);
            const subtitleRight = getLastNChars(immCard.get('number'));
            const { expandedRowId } = this.state;
            const breadcrumbcardPeriodicLoads = formatText('breadcrumb-cardPeriodicLoads')
                .split(' ')
                .map((str) => toFirstUppercase(str))
                .join(' ');
            const baseUrl = '/myprofile/cards';
            const mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-cards'),
                    url: baseUrl
                },
                {
                    text: immCard ? immCard.get('alias').get('current') : '',
                    url: `${baseUrl}/${cardId}/movements`
                },
                {
                    text: breadcrumbcardPeriodicLoads
                }
            ];
            const tutorial = (
                <TutorialLauncher
                    type={GRAPHIC_TUTOR_TYPE_3}
                    title={formatText('tutorials-cardPeriodicLoadsTitle')}
                />
            );
            let bodyContent;
            if (cardPeriodicLoads.get('getLoadsListFetch')) {
                bodyContent = (
                    <LoadingSection />
                );
            } else if (cardPeriodicLoads.get('getLoadsListError')) {
                const retryButton = (
                    <OKButton onClick={() => {
                        this.getList();
                    }}>
                        <FormattedText value="cardPeriodicLoads-retryButton" />
                    </OKButton>
                );

                bodyContent = (
                    <EmptyState
                        primaryText={formatText('cardPeriodicLoads-connectionError')}
                        button={retryButton}
                        iconType="nointernet-banking"
                    />
                );
            } else if (cardPeriodicLoads.get('byOrder').size === 0) {
                let formatValue = 'emptyList';
                if (immFilters.getIn(['amount', 'isActive']) || immFilters.getIn(['periodicity', 'isActive'])) {
                    formatValue = 'emptyListByFilters';
                }
                bodyContent = (
                    <EmptyState
                        primaryText={formatText(`cardPeriodicLoads-${formatValue}`)}
                        iconType="search-banking"
                    />
                );
            } else if (cardPeriodicLoads.get('byOrder').size > 0 && !isEmpty(cardPeriodicLoads.get('byId'))) {
                const tableHeaders = ['startDate', 'endDate', 'periodicity', 'periodicityConcept', 'amount'];
                const tableHeaderClasses = ['start-date', 'end-date', 'periodicity', 'periodicity-concept', 'amount'];
                const tableHeaderElements = tableHeaders.map((header, index) => (
                    <OKTableCell
                        className={`card-periodic-loads-view__header-cell--${tableHeaderClasses[index]}`}
                        asHeader={true}
                        key={index}
                    >
                        <FormattedText format="uppercase" value={`cardPeriodicLoads-${header}`} />
                    </OKTableCell>
                ));
                bodyContent = (
                    <LastMovementsTable
                        columnsCount={7}
                        currentMonthKey={LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY}
                        expandedRowComponent={PeriodicLoadsTableInfoRow}
                        expandedRowId={expandedRowId}
                        groupByDate={true}
                        id="load-list-table"
                        immTransactionsById={cardPeriodicLoads.get('byId')}
                        immTransactionsByOrder={cardPeriodicLoads.get('byOrder')}
                        language={language}
                        onRowClick={this.handleRowClick}
                        rowComponent={PeriodicLoadsTableRow}
                    >
                        <thead>
                            <OKTableRow asHeader={true}>
                                <OKTableCell
                                    asHeader={true}
                                    className="card-periodic-loads-view__header-cell--toggler"
                                />
                                {tableHeaderElements}
                                <OKTableCell asHeader={true} />
                            </OKTableRow>
                        </thead>
                    </LastMovementsTable>
                );
            }

            const cardMoreOptionsButton = (
                <CardMoreOptionsButton
                    immCard={immCard}
                    cardId={cardId}
                    flagBasedFeatures={flagBasedFeatures}
                />
            );

            let cardMoreOptionsButtonMobile;
            let cardMoreOptionsButtonDesktop;

            if (immScreen.get('isMobile')) {
                cardMoreOptionsButtonMobile = cardMoreOptionsButton;
            } else {
                cardMoreOptionsButtonDesktop = cardMoreOptionsButton;
            }
            return (
                <div>
                    <div className="container-fluid">
                        <div className="row">
                            <OKCover size="medium" section="cards" customClass="col-xs-12">
                                <OKHeaderSubPage
                                    breadcrumbConfig={mappingBreadcrumb}
                                    subtitleLeft={subtitleLeft}
                                    subtitleRight={subtitleRight}
                                    titleIsEditable={true}
                                    titleEditable={titleEditable}
                                    titleEditableAction={this.onPostAlias}
                                    tutorial={tutorial}
                                >
                                    <div>
                                        {cardMoreOptionsButtonMobile}
                                        <CardHeaderDetails
                                            immCard={immCard}
                                            isFetching={false}
                                            rightSpace={true}
                                        />
                                        {cardMoreOptionsButtonDesktop}
                                    </div>
                                </OKHeaderSubPage>
                            </OKCover>
                        </div>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-negative">
                                <div className="col-xs-12 col-md-12">
                                    <div className="card-periodic-loads-view">
                                        <header className="clearfix card-periodic-loads-view__header">
                                            <div className="pull-left">
                                                <OKBoxTitle value={formatText('cardPeriodicLoads-title')} />
                                            </div>
                                            <div className="pull-right card-periodic-loads-view__filters">
                                                <OKButton
                                                    modifier="task"
                                                    onClick={this.handleToggleFilters}
                                                >
                                                    <i className="icon-filtrar" />
                                                </OKButton>
                                            </div>
                                        </header>
                                        <PeriodicLoadsAppliedFilter
                                            immFilters={immFilters}
                                            onHandleClearFilters={this.handleClearFilters}
                                            onHandleResetFilters={this.handleResetFilters}
                                        />
                                        {bodyContent}
                                        <PeriodicLoadsFilter
                                            onFilterSubmit={this.handleSetFilters}
                                            immFilters={immFilters}
                                            isOpen={this.state.filterSettingsOpen}
                                            onCloseClick={this.handleToggleFilters}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

CardPeriodicLoadsView.propTypes = {
    cardPeriodicLoads: PropTypes.object.isRequired,
    clearFilters: PropTypes.func,
    getPeriodicLoadsList: PropTypes.func,
    immAccounts: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immScreen: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    postAlias: PropTypes.func.isRequired,
    resetFilters: PropTypes.func,
    setFilters: PropTypes.func,
    flagBasedFeatures: PropTypes.object
};

module.exports.constructor = CardPeriodicLoadsView;
module.exports.CardPeriodicLoadsView = connect(
    state => ({
        cardPeriodicLoads: state.cardPeriodicLoads,
        immAccounts: state.accounts,
        immCards: state.cards,
        immScreen: state.screen,
        flagBasedFeatures: state.flagBasedFeatures
    }),
    {
        clearFilters: cardPeriodicLoadsActions.requestClearOpenYoungCardPeriodicLoadsFilter,
        getPeriodicLoadsList: cardPeriodicLoadsActions.getPeriodicLoadsList,
        postAlias: cardsAliasActions.postCardAlias,
        resetFilters: cardPeriodicLoadsActions.requestResetOpenYoungCardPeriodicLoadsFilter,
        setFilters: cardPeriodicLoadsActions.applyOpenYoungPeriodicLoadsFilter
    }
)(CardPeriodicLoadsView);
